module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/home/home.html
// module id = 601
// module chunks = 0